import { ApplicationErrorType } from "./application-error.types";
import { CoreServerError } from "../models/core-server-error";
import { ApplicationError } from "./application-error";

/**
 * Extension of the ApplicationError class for Http errors
 */
export class HttpApplicationError extends ApplicationError
{
    //#region Constructor

    /**
     * Class constructor
     * @param message  text to display
     * @param device device info
     * @param applicationVersion application version
     * @param userAgent envioument 
     * @param httpStatusCode status code of request
     * @param url url request 
     * @param coreServerError core server error information
     */
    constructor
        (
            message: string,
            device: string,
            applicationVersion: string,
            softwareVersion,
            userAgent: string,
            httpStatusCode: number,
            url: string,
            coreServerError: CoreServerError

        )
    {
        super(message, ApplicationErrorType.ERROR_HTTP, device, applicationVersion, softwareVersion, userAgent);
        this.HttpStatusCode = httpStatusCode;
        this.Url = url;
        this.CoreServerError = coreServerError;
    }

    //#endregion

    //#region Properties

    /**
     * Http Status Code
     */
    public HttpStatusCode: number;

    /**
     * Request Url
     */
    public Url: string;

    /**
     * Core server error
     */
    public CoreServerError: CoreServerError

    //#endregion
}
